import { colors } from "theme/colors"
import { RoutesTypesInterface } from "types/interfaces"


const routes: RoutesTypesInterface = {
  items: [
    {
      page: 'home',
      path: '/',
      type: 'portal',
      colorTheme: colors.home.bold
    },
    {
      page: 'devotion',
      path: '/devocao',
      type: 'devotion',
      colorTheme: colors.devotion.bold
    }
  ]
}

export default routes